import { ENV_JS } from "../utils/env_module"
/**
 * Created by Dev0 on 29.08.14.
 * Main Callpy class - creates instances of all other classes & defines constants
 */

function CallpyGlobal() {
    //инициализация класса
    this.modules = {};
    this.php_server = ENV_JS.CALLPY_PHP_SERVER;
    this.callpy_domain = ENV_JS.CALLPY_SERVER;
    this.language = ENV_JS.CALLPY_LANGUAGE;
    this.rplx_server = ENV_JS.CALLPY_RPLX_SERVER;
    this.manager_avatar_path = this.php_server + "images/avatar/";
    this.manager_avatar_extension = ".jpg";
    this.errorLevel = "ALL"; //Возможные значения - см. в CLogger
    //console.log('CallpyGlobal', this)

}

CallpyGlobal.prototype = {
    registerModule: function(moduleName){
        var module = false;
        try{
            module = eval(moduleName);
        }catch(e){
            console.error("Global Error:", e);
        }
        if (typeof module == "function"){
            if (!this.modules[moduleName])
            {
                module = new module();
                this.modules[moduleName] = true;
                console.log("Module Registred : " + moduleName)
            }
            else
            {
                console.warn("Module " + moduleName + " already registred!")
            }
        }else{
            console.warn("Module " + moduleName + " does not exist!");
        }
        return module;
    },
    extend: function() {
        for (var p in {toString: null}) {
            return function extend(o) {
                for (var i=1; i<arguments.length; i++){
                    var source = arguments[i];
                    for (var prop in source) o[prop] = source[prop];
                }
                return o;
            };
        }
        var protoprops = ["toString", "valueOf", "constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString"];
        return function patched_extend(o){
            for (var i=1; i<arguments.length; i++){
                var source = arguments[i];
                for (var prop in source) o[prop] = source[prop];
                for (var j=0; j<protoprops.length; j++){
                    prop = protoprops[j];
                    if (source.hasOwnProperty(prop)) o[prop] = source[prop];
                }
            }
            return o;
        };
    }
};

const callpy_global = new CallpyGlobal();
window.callpy_global = callpy_global
//console.log('callpy_global', callpy_global)